import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { LoadingSpinnerDefaultHeight, LoadingSpinnerSize, LoadingSpinnerDisplayMode, LoadingSpinnerPosition, LoadingSpinnerColorScheme } from './loading-spinner.constants';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule]
})
export class LoadingSpinnerComponent implements OnInit {
  LoadingSpinnerDisplayMode = LoadingSpinnerDisplayMode;
  @Input() overlay: boolean = false;
  @Input() size: LoadingSpinnerSize = LoadingSpinnerSize.MEDIUM;
  @Input() defaultHeight: LoadingSpinnerDefaultHeight = LoadingSpinnerDefaultHeight.MEDIUM;
  @Input() displayMode: LoadingSpinnerDisplayMode = LoadingSpinnerDisplayMode.BLOCK;
  @Input() position: LoadingSpinnerPosition = LoadingSpinnerPosition.END;
  @Input() color: LoadingSpinnerColorScheme = LoadingSpinnerColorScheme.AP_BLUE;

  overlayClass: string;
  positionClass: string;
  sizeClass: string;
  defaultHeightClass: string;
  colorSchemeClass: string;

  constructor() {

  }

  ngOnInit() {
    this.overlayClass = this.overlay ? 'container-overlay' : '';
    this.positionClass = this.getPositionClass();
    this.sizeClass = this.getSizeClass();
    this.defaultHeightClass = this.getDefaultHeightClass();
    this.colorSchemeClass = this.getColorSchemeClass();
  }

  getPositionClass = () => {
    let marginClass = this.position === LoadingSpinnerPosition.CENTER ? '' : (this.position === LoadingSpinnerPosition.START ? 'me-2' : 'ms-2');
    let className = this.position === LoadingSpinnerPosition.CENTER ? '' : `float-${this.position.toLowerCase()} ${marginClass}`;
    return className.trim();
  }

  getSizeClass = () => {
    return `spinner-${this.size.toLowerCase()}`;
  }

  getDefaultHeightClass = () => {
    return this.defaultHeight ? `default-height-${this.defaultHeight.toLowerCase()}` : '';
  }
  getColorSchemeClass = () => {
    let result = `color-scheme-${this.color.toLowerCase()}`;
    return result;
  }
}
